import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import UserProfileFirstStyle from "./UserProfileFirstStyle/UserProfileFirstStyle";
import UserProfileThirdStyle from "./UserProfileThirdStyle/UserProfileThirdStyle";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Tour } from "../../../Constants/Constants";

const TourMain = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Tour} parent={BonusUi} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <UserProfileFirstStyle />
            <UserProfileThirdStyle />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default TourMain;
